"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAPIFactory = void 0;
const createAPIFactory = (methods) => (caller) => {
    return Object.entries(methods).reduce((api, [methodName, method]) => {
        return {
            ...api,
            [methodName]: method(caller),
        };
    }, {});
};
exports.createAPIFactory = createAPIFactory;
//# sourceMappingURL=createApi.js.map